import { render, staticRenderFns } from "./Brand.vue?vue&type=template&id=158341ec&scoped=true"
import script from "./Brand.vue?vue&type=script&lang=ts"
export * from "./Brand.vue?vue&type=script&lang=ts"
import style0 from "./Brand.vue?vue&type=style&index=0&id=158341ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "158341ec",
  null
  
)

export default component.exports